import React from 'react';
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import styles from './styles/styles';
import EquipmentTranslationsForm from './EquipmentTranslationsForm';
import {
  getEquipmentsTranslation,
  UpdateEquipmentsTranslation,
} from '../../redux/actions/equipmentsActions';
import { snackbarShowMessage } from '../../redux/actions/snackbarActions';
import { useTranslation } from 'react-i18next';

const EquipmentTranslationsModal = ({
  OpenEquipmentTranslation,
  handleClose,
  EquipmentSelected,
}: any) => {
  const selectedBrand = useSelector(
    (state: RootStateOrAny) => state.UIReducer.selectedBrand,
  );
  const classes = styles();
  const dispatch: any = useDispatch();

  const SaveTranslations = values => {
    const newValues = Object.keys(values).map(key => ({
      languageId: ~~key,
      value: values[key] === '' ? null : values[key],
    }));
    UpdateEquipmentsTranslation(
      EquipmentSelected,
      selectedBrand,
      newValues,
    )(dispatch).then(result => {
      if (result.status === 400) {
        dispatch(snackbarShowMessage('equipment.translations.lengthError'));
      } else {
        dispatch(snackbarShowMessage('equipment.translations.saveSuccess'));
        dispatch(getEquipmentsTranslation(EquipmentSelected, selectedBrand));
        handleClose();
      }
    });
  };

  const { t } = useTranslation();

  return (
    <Dialog
      maxWidth="lg"
      open={OpenEquipmentTranslation}
      onClose={handleClose}
      aria-labelledby="max-width-dialog-title"
      disableBackdropClick={true}
      disableEscapeKeyDown={true}
    >
      <DialogContent style={{ minHeight: '80vh' }}>
        <DialogTitle
          id="alert-dialog-title"
          className={classes.containerDialogTitle}
        >
          <div className={classes.divItems}>
            <Typography variant="h6">{t('app.common.translations')}</Typography>
            <IconButton
              style={{ position: 'relative', marginLeft: '56px', padding: '0' }}
              onClick={handleClose}
            >
              <CloseIcon />
            </IconButton>
          </div>
        </DialogTitle>
        <EquipmentTranslationsForm
          SaveTranslations={SaveTranslations}
          CloseModal={handleClose}
        />
      </DialogContent>
    </Dialog>
  );
};

export default EquipmentTranslationsModal;
